import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { ButtonComponent } from "daisy-design-system-front";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: "app-dialog-confirm",
  templateUrl: "./dialog-confirm.component.html",
  styleUrls: ["./dialog-confirm.component.scss"],
  standalone: true,
  imports: [CommonModule, MatDialogModule, ButtonModule, ButtonComponent, TranslateModule],
})
export class DialogConfirmComponent {
  public data!: DialogConfirmData | undefined;

  constructor(
    private readonly ref: DynamicDialogRef,
    public config: DynamicDialogConfig<DialogConfirmData>
  ) {
    this.data = this.config.data;
  }

  closeMe(accept = false) {
    this.ref.close({ accept });
  }
}

class DialogConfirmData {
  message!: string;
  yesButtonLabel!: string;
  yesButtonIcon!: string;
  noButtonLabel!: string;
  noButtonIcon!: string;
}
